// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import styled from '@emotion/styled';
import Link from 'presentations/views/components/atoms/Link';
import CalendarHeader from 'presentations/views/components/organisms/Header';
import Footer from 'presentations/views/components/organisms/Footer';
import {
  deviceSizes,
  fontSize,
  fontWeight,
  mediaMax,
  mediaMin,
  spacing,
  zIndex,
} from 'presentations/views/styles';
import Breadcrumbs from 'presentations/views/components/organisms/Breadcrumbs';
import Breadcrumb from 'presentations/routes/breadcrumb';
import { useSourceTrack } from 'presentations/views/hooks/track';
import { gray04, primary, white } from 'presentations/views/styles/color';
import FooterContentBanner from 'presentations/views/components/molecules/OwnedContentBanner/FooterContentBanner';
import SubContentBanner from 'presentations/views/components/molecules/OwnedContentBanner/SubContentBanner';
import SubContentImageBanner from 'presentations/views/components/molecules/OwnedContentBanner/SubContentImageBanner';
import { ProductType } from 'domains/models/blog_post/productType';
import {
  appCalendarFilterPath,
  appCalendarMonthPath,
} from 'presentations/routes/path';
import { ReactNode, useEffect, useState } from 'react';
import HolidayList from 'presentations/views/components/organisms/apps/HolidayList';
import { subImageAdId } from 'presentations/views/components/molecules/OwnedContentBanner';

declare global {
  interface Window {
    adsbygoogle: any;
    registration: any;
  }
}

interface Props {
  children: ReactNode;
  routes?: Breadcrumb[];
  year?: number;
  month?: number;
  filter?: string;
  holidays?: any;
  holidayMasters?: any;
  isHeaderStatic?: boolean;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const adId = subImageAdId;

  const date =
    props.year && props.month
      ? new Date(props.year, props.month - 1, 1)
      : new Date();
  const campaign = {
    medium: 'apps-calendar',
  };
  useSourceTrack(campaign);
  useEffect(() => {
    // (window.adsbygoogle || []).push({});
    // (window.adsbygoogle || []).push({});
  }, []);

  return (
    <Container>
      <HeaderContainer isStatic={props.isHeaderStatic}>
        <CalendarHeader
          viewer={null}
          // isHideLogin
          isHideServiceMenu
        />
      </HeaderContainer>
      <Content>
        <Main>{props.children}</Main>
        <Sub>
          <SubAdContainer>
            {/* {adId === 'default' ? (
              <SubContentBanner
                productType={ProductType.Calendar}
                name="calendar"
              />
            ) : ( */}
            <SubContentImageBanner
              productType={ProductType.Calendar}
              name="calendar"
              adId={adId}
            />
            {/* )} */}
          </SubAdContainer>
          {props.holidays && (
            <HolidayListContainer>
              <Headline>{t('holidayTitle', { date })}</Headline>
              <HolidayList
                holidays={props.holidays}
                holidayMasters={props.holidayMasters}
              />
            </HolidayListContainer>
          )}
          {!props.filter && (
            <ListContainer>
              <Headline>{t('searchTitle')}</Headline>
              <LinkListContainer>
                <LinkListInner>
                  <LinkListTitle>{t('displayTypeTitle')}</LinkListTitle>
                  <LinkListContent>
                    <LinkList>
                      <LinkListItem>
                        <Link
                          href={appCalendarMonthPath(
                            date.getFullYear(),
                            date.getMonth() + 1,
                          )}
                        >
                          <LinkListItemLink>
                            {t('rokuyoCalendar')}
                          </LinkListItemLink>
                        </Link>
                      </LinkListItem>
                      <LinkListItem>
                        <Link href={appCalendarFilterPath('moon')}>
                          <LinkListItemLink>
                            {t('moonAgeCalendar')}
                          </LinkListItemLink>
                        </Link>
                      </LinkListItem>
                    </LinkList>
                  </LinkListContent>
                </LinkListInner>
                <LinkListInner>
                  <LinkListTitle>{t('filterTypeTitle')}</LinkListTitle>
                  <LinkListContent>
                    <LinkList>
                      <LinkListItem>
                        <Link href={appCalendarFilterPath('taian')}>
                          <LinkListItemLink>
                            {t('taianCalendar')}
                          </LinkListItemLink>
                        </Link>
                      </LinkListItem>
                    </LinkList>
                  </LinkListContent>
                </LinkListInner>
              </LinkListContainer>
            </ListContainer>
          )}
        </Sub>
      </Content>
      <AdFooter>
        <FooterContentBanner
          productType={ProductType.Calendar}
          name="calendar"
        />
      </AdFooter>
      <Breadcrumbs routes={props.routes} />
      <FooterContainer>
        <Footer />
      </FooterContainer>
    </Container>
  );
}

const Container = styled.div``;
const Content = styled.div`
  max-width: ${`${deviceSizes.desktop}px`};
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  ${mediaMax.desktop} {
    display: block;
  }
`;
const Main = styled.div`
  flex: 1;
  margin-top: ${spacing(48)};
  ${mediaMax.desktop} {
    margin-left: 0;
    margin-top: 0;
    width: 100%;
  }
`;
const Sub = styled.div`
  margin-left: ${spacing(16)};
  margin-top: ${spacing(48)};
  width: 350px;
  ${mediaMax.desktop} {
    margin-top: 0;
    margin-left: 0;
    width: 100%;
  }
`;
const FooterContainer = styled.div`
  margin-top: ${spacing(16)};
`;
const HeaderContainer = styled.div<{ isStatic?: boolean }>`
  position: ${(props) => !props.isStatic && 'sticky'};
  top: 0px;
  left: 0px;
  z-index: 1300;
  background-color: ${white};
`;

export const AdFooter = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: ${zIndex(1100)};
  ${mediaMax.tablet} {
    /* display: none; */
  }
`;

const LinkListContainer = styled.dl`
  ${mediaMin.tablet} {
    padding: ${spacing(24)} 0 ${spacing(12)};
  }
`;
const LinkListTitle = styled.dt`
  font-size: ${fontSize(14)};
  flex-shrink: 0;
  padding-top: ${spacing(16)};
  ${mediaMin.tablet} {
    font-size: ${fontSize(16)};
    padding-top: 0;
    padding-right: 1em;
  }
`;
const LinkListInner = styled.div`
  border-top: 1px solid ${gray04};
  ${mediaMin.tablet} {
    border-top: 0;
    font-size: ${fontSize(16)};
    display: flex;
    :not(:first-of-type) {
      margin-top: ${fontSize(12)};
    }
  }
`;
const LinkListContent = styled.dd`
  width: 100%;
  padding: ${spacing(16)} 0 0;
  ${mediaMin.tablet} {
    padding: 0;
  }
`;
const LinkList = styled.ul`
  display: flex;
  flex-wrap: wrap;
`;
const LinkListItem = styled.li`
  font-size: ${fontSize(14)};
  padding-right: ${spacing(24)};
  margin-bottom: ${spacing(16)};
  ${mediaMin.tablet} {
    font-size: ${fontSize(16)};
    margin-bottom: ${spacing(12)};
  }
`;
const LinkListItemLink = styled.a`
  color: ${primary};
  ${mediaMax.tablet} {
    display: block;
  }
  &:hover {
    color: ${primary};
    text-decoration: underline;
  }
`;

const ListContainer = styled.div`
  margin-bottom: ${spacing(48)};
  padding: ${spacing(16)} 0;
  ${mediaMax.tablet} {
    padding: ${spacing(16)};
    margin-bottom: ${spacing(32)};
  }
`;

const Headline = styled.div`
  font-size: ${fontSize(18)};
  font-weight: ${fontWeight('bold')};
  text-align: center;
  margin-bottom: ${spacing(16)};
  ${mediaMax.desktop} {
  }
`;
const HolidayListContainer = styled.div`
  margin-bottom: ${spacing(48)};
  ${mediaMax.tablet} {
    margin: 0 ${spacing(16)} ${spacing(32)};
  }
`;

const SubAdContainer = styled.div`
  margin-bottom: ${spacing(48)};
  ${mediaMax.desktop} {
    /* display: none; */
  }
`;
